var exports = {
  "MY": "invisibleWithBorder__XJQ0D0",
  "wH": "selected__p7xj_F",
  "sP": "titleWithShield__8KjDZP",
  "TX": "sixVisibleItems__GoJvk6",
  "gd": "restrictionShield__vwqSIr",
};

module.exports = exports;
